const adminBase = process.env.REACT_APP_API_SERVER || '';
const publicApiBase = (
  process.env.REACT_APP_API_SERVER_PUBLIC ||
  adminBase.replace(/\/admin\/?$/, '/')
).trim().replace(/\/?$/, '/');

export const Config = {
  API_SERVER: adminBase,
  /** 공개 공통코드 GET /api/code/detail (로그인 불필요 — NG11·NG02·NG14) */
  API_CODE_DETAIL:
    process.env.REACT_APP_API_CODE_DETAIL || `${publicApiBase}code/detail`,
  /** 상점관리자 공통코드 GET /api/admin/code/detail (로그인 필요) */
  API_ADMIN_CODE_DETAIL:
    process.env.REACT_APP_API_ADMIN_CODE_DETAIL ||
    `${adminBase.replace(/\/?$/, '/')}code/detail`,
  /** 공개 사업자등록상태 조회 POST /api/biz-validation/status — 국세청 API를 백엔드가 대행 호출 */
  API_BIZ_VALIDATION_STATUS:
    process.env.REACT_APP_API_BIZ_VALIDATION_STATUS ||
    `${publicApiBase}biz-validation/status`,
  /** operator CRUD base (조회·등록·수정·삭제 — 운영자) */
  API_SERVER_OPERATOR:
    process.env.REACT_APP_API_SERVER_OPERATOR ||
    adminBase.replace(/\/admin\/?$/, '/operator/'),
  SHOPMAIN_SERVER: process.env.REACT_APP_SHOPMAIN_SERVER,
  SHOPADMIN_SERVER: process.env.REACT_APP_SHOPADMIN_SERVER,
  SHOPUSER_SERVER: process.env.REACT_APP_SHOPUSER_SERVER,
  OPENAI_SERVER: process.env.REACT_APP_OPENAI_SERVER,
  OPENAI_KEY1: process.env.REACT_APP_OPENAI_KEY1,
  OPENAI_KEY2: process.env.REACT_APP_OPENAI_KEY2,
  OPENAI_Endpoint: process.env.REACT_APP_OPENAI_Endpoint,
  GEMINI_API_KEY: process.env.REACT_APP_GEMINI_API_KEY,
  GEMINI_API_URL:
    process.env.REACT_APP_GEMINI_API_URL ||
    'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent',
  GEMINI_IMAGE_MODEL:
    process.env.REACT_APP_GEMINI_IMAGE_MODEL || 'gemini-2.5-flash-image',
  PAGE_SIZE_LIST: [10, 50, 100, 200],
};
